import { Breakpoint, Breakpoints } from 'bold-ui'

export function betweenBreakpoints(breakpoints: Breakpoints, lower: Breakpoint, upper: Breakpoint): string {
  return `@media (min-width: ${breakpoints.size[lower] + 1}px) and (max-width: ${breakpoints.size[upper] - 1}px)`
}
